var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.projectLoaded && _vm.projects.total > 0)?_c('div',[_c('SliderRelated',{attrs:{"section-title":"Closeby Proyek","strings":this.$root.$data.strings,"projects":_vm.projects.projects}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }